var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuccessIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 0.375C3.39453 0.375 0.5 3.29492 0.5 6.875C0.5 10.4805 3.39453 13.375 7 13.375C10.5801 13.375 13.5 10.4805 13.5 6.875C13.5 3.29492 10.5801 0.375 7 0.375ZM9.91992 5.75781L6.66992 9.00781C6.54297 9.16016 6.36523 9.21094 6.1875 9.21094C5.98438 9.21094 5.80664 9.16016 5.67969 9.00781L4.05469 7.38281C3.77539 7.10352 3.77539 6.67188 4.05469 6.39258C4.33398 6.11328 4.76562 6.11328 5.04492 6.39258L6.1875 7.50977L8.92969 4.76758C9.20898 4.48828 9.64062 4.48828 9.91992 4.76758C10.1992 5.04688 10.1992 5.47852 9.91992 5.75781Z",
    fill: "#38AF49"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessIcon);
export default __webpack_public_path__ + "static/media/success-icon.9476e8a37da0c943260852794d4496dc.svg";
export { ForwardRef as ReactComponent };